/* La Reveni theme. Built from src/js/*.js by tools/build.sh. Do not edit here. */
/* =============================================================================
   La Reveni theme: core. Vanilla JS, no dependencies, no jQuery.
   Drawers, header, reveals, accordions, filters, load more, search, misc.
   ========================================================================== */
(function () {
  'use strict';

  var LR = (window.LR = window.LR || {});
  LR.routes = LR.routes || {};
  LR.settings = LR.settings || {};
  LR.strings = LR.strings || {};

  var doc = document;
  var root = doc.documentElement;

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  var store = {
    get: function (key) {
      try { return JSON.parse(window.localStorage.getItem(key)); } catch (e) { return null; }
    },
    set: function (key, value) {
      try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* private mode */ }
    }
  };

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function toast(message, ms) {
    var el = $('[data-toast]');
    if (!el || !message) return;
    el.textContent = message;
    el.hidden = false;
    el.style.animation = 'none';
    void el.offsetWidth;
    el.style.animation = '';
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { el.hidden = true; }, ms || 1800);
  }

  // Replace an element's children with server-rendered markup, via DOMParser (no innerHTML).
  // Scripts in the markup never run; the HTML always comes from this store's own Liquid output.
  function setHTML(el, html) {
    var parsed = new DOMParser().parseFromString(html || '', 'text/html');
    var nodes = Array.prototype.slice.call(parsed.body.childNodes).map(function (n) { return doc.importNode(n, true); });
    el.replaceChildren.apply(el, nodes);
  }

  LR.$ = $;
  LR.$$ = $$;
  LR.store = store;
  LR.toast = toast;
  LR.debounce = debounce;
  LR.setHTML = setHTML;

  /* --- drawers ------------------------------------------------------------ */
  var Drawers = {
    overlay: null,
    current: null,
    lastFocus: null,

    ensureOverlay: function () {
      if (!this.overlay) {
        var o = doc.createElement('div');
        o.className = 'drawer-overlay';
        o.hidden = true;
        doc.body.appendChild(o);
        var self = this;
        o.addEventListener('click', function () { self.close(); });
        this.overlay = o;
      }
      return this.overlay;
    },

    open: function (name) {
      var el = $('[data-drawer="' + name + '"]');
      if (!el) return false;
      if (this.current === el) return true;
      if (this.current) this.close(true);

      this.lastFocus = doc.activeElement;
      var overlay = this.ensureOverlay();
      el.hidden = false;
      if (name !== 'menu') overlay.hidden = false;
      void el.offsetWidth;
      el.classList.add('is-open');
      if (name !== 'menu') overlay.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      doc.body.classList.add('has-drawer');
      $$('[data-drawer-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      this.current = el;

      var target = $('[data-predictive-input]', el) || $('.drawer__close', el) || el;
      setTimeout(function () { try { target.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }, 60);
      doc.dispatchEvent(new CustomEvent('lr:drawer-open', { detail: { name: name, el: el } }));
      return true;
    },

    close: function (immediate) {
      var el = this.current;
      if (!el) return;
      var self = this;
      this.current = null;
      el.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      doc.body.classList.remove('has-drawer');
      $$('[data-drawer-open][aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });

      var finish = function () {
        if (!el.classList.contains('is-open')) el.hidden = true;
        if (self.overlay && !self.current) self.overlay.hidden = true;
      };
      if (immediate) finish(); else setTimeout(finish, 460);

      if (this.lastFocus && this.lastFocus.focus) {
        try { this.lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
      }
      doc.dispatchEvent(new CustomEvent('lr:drawer-close', { detail: { el: el } }));
    },

    trap: function (e) {
      if (e.key !== 'Tab' || !this.current) return;
      var focusables = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', this.current)
        .filter(function (n) { return n.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };
  LR.Drawers = Drawers;

  doc.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      Drawers.open(opener.getAttribute('data-drawer-open'));
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      e.preventDefault();
      Drawers.close();
    }
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && Drawers.current) Drawers.close();
    else Drawers.trap(e);
  });

  /* --- header: compacts on scroll, signature draws once per session ---------- */
  var scrolled = false;
  function onScroll() {
    var s = window.scrollY > 40;
    if (s !== scrolled) {
      scrolled = s;
      if (s) root.setAttribute('data-scrolled', ''); else root.removeAttribute('data-scrolled');
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if (LR.settings.drawSignature !== false && !root.classList.contains('sig-done')) {
    setTimeout(function () {
      try { window.sessionStorage.setItem('lr_sig', '1'); } catch (e) { /* ignore */ }
    }, 3200);
  }

  /* --- scroll reveals (fade + rise) ------------------------------------------ */
  var revealObserver = null;
  function observeReveals(ctx) {
    var nodes = $$('[data-reveal]:not(.is-in)', ctx);
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('is-in');
            revealObserver.unobserve(en.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    nodes.forEach(function (n) { revealObserver.observe(n); });
  }
  LR.observeReveals = observeReveals;

  /* --- accordions (product + FAQ) --------------------------------------------- */
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-acc-btn]');
    if (!btn) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    var group = btn.closest('[data-accordion]');
    if (group && group.hasAttribute('data-single') && !open) {
      $$('[data-acc-btn][aria-expanded="true"]', group).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
  });

  /* --- selects that submit on change (language / currency) -------------------- */
  doc.addEventListener('change', function (e) {
    var sel = e.target.closest('select[data-auto-submit]');
    if (sel && sel.form) sel.form.submit();
  });

  /* --- collection: sort + load more -------------------------------------------- */
  doc.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-sort-select]');
    if (!sort) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  doc.addEventListener('click', function (e) {
    var more = e.target.closest('[data-load-more]');
    if (!more) return;
    e.preventDefault();
    if (more.classList.contains('is-loading')) return;
    more.classList.add('is-loading');
    more.setAttribute('aria-busy', 'true');
    fetch(more.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html');
        var grid = $('[data-collection-grid]');
        var nextGrid = $('[data-collection-grid]', next);
        if (grid && nextGrid) {
          Array.prototype.slice.call(nextGrid.children).forEach(function (child) {
            grid.appendChild(doc.importNode(child, true));
          });
          observeReveals(grid);
        }
        var nextBtn = $('[data-load-more]', next);
        if (nextBtn) {
          more.href = nextBtn.getAttribute('href');
          more.classList.remove('is-loading');
          more.removeAttribute('aria-busy');
        } else {
          var wrap = more.closest('.coll__more');
          if (wrap) wrap.remove(); else more.remove();
        }
      })
      .catch(function () {
        more.classList.remove('is-loading');
        more.removeAttribute('aria-busy');
        window.location.href = more.href;
      });
  });

  /* --- size tables: cm / in toggle ---------------------------------------------- */
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-unit-btn]');
    if (!btn) return;
    var wrap = btn.closest('[data-size-tables]');
    if (!wrap) return;
    var unit = btn.getAttribute('data-unit-btn');
    wrap.setAttribute('data-unit', unit);
    $$('[data-unit-btn]', wrap).forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  });

  /* --- Fit Finder (brief 6.4 #8) --------------------------------------------------
     band = round(underbust / 5) * 5 (-5 snug, +5 relaxed)
     cup  = ['AA','A','B','C','D','E','F','G'][round((bust - underbust - 10) / 2)] clamped */
  doc.addEventListener('click', function (e) {
    var pref = e.target.closest('[data-fit-pref]');
    if (!pref) return;
    var form = pref.closest('[data-fit-form]');
    $$('[data-fit-pref]', form).forEach(function (b) {
      var on = b === pref;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  });
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-fit-form]');
    if (!form) return;
    e.preventDefault();
    var under = parseFloat($('[data-fit-under]', form).value);
    var bust = parseFloat($('[data-fit-bust]', form).value);
    var result = $('[data-fit-result]', form);
    var size = $('[data-fit-size]', form);
    var note = $('[data-fit-note]', form);
    if (!under || !bust) {
      size.textContent = '';
      note.textContent = LR.strings.missing || '';
      result.hidden = false;
      return;
    }
    var activePref = $('[data-fit-pref].is-active', form);
    var pref = activePref ? parseInt(activePref.getAttribute('data-fit-pref'), 10) : 1;
    var band = Math.round(under / 5) * 5;
    if (pref === 0) band -= 5;
    if (pref === 2) band += 5;
    var cups = ['AA', 'A', 'B', 'C', 'D', 'E', 'F', 'G'];
    var idx = Math.max(0, Math.min(cups.length - 1, Math.round((bust - under - 10) / 2)));
    size.textContent = band + cups[idx] + ' ' + (LR.strings.resultEu || '(EU)');
    if (!note.hasAttribute('data-default')) note.setAttribute('data-default', note.textContent);
    note.textContent = note.getAttribute('data-default');
    result.hidden = false;
    result.style.animation = 'none';
    void result.offsetWidth;
    result.style.animation = '';
  });

  /* --- predictive search ----------------------------------------------------------- */
  var searchInput = null;
  function runPredictive() {
    if (!searchInput) return;
    var box = $('[data-predictive-results]');
    var q = searchInput.value.trim();
    if (!box) return;
    if (q.length < 2) { box.replaceChildren(); return; }
    var url = (LR.routes.predictiveSearch || '/search/suggest') +
      '?q=' + encodeURIComponent(q) +
      '&section_id=predictive-search&resources[limit]=6&resources[type]=product,collection,page,article';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var inner = $('[data-predictive-results-inner]', parsed);
        if (inner) box.replaceChildren(doc.importNode(inner, true)); else box.replaceChildren();
      })
      .catch(function () { /* the full search form still works */ });
  }
  doc.addEventListener('input', function (e) {
    var input = e.target.closest('[data-predictive-input]');
    if (!input) return;
    searchInput = input;
    debounce(runPredictive, 250)();
  });

  /* --- misc: password recover toggle on classic login ---------------------------- */
  doc.addEventListener('click', function (e) {
    var t = e.target.closest('[data-recover-toggle]');
    if (!t) return;
    e.preventDefault();
    var box = $('#recover');
    if (box) box.hidden = !box.hidden;
  });
  doc.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-confirm]');
    if (f && !window.confirm('OK?')) e.preventDefault();
  });

  /* --- init ---------------------------------------------------------------------------- */
  function init() {
    observeReveals(doc);
    doc.dispatchEvent(new CustomEvent('lr:ready'));
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();
/* =============================================================================
   Cart: slide-out bag, add / change / remove, quick add, gift note, discount code.
   The bag is re-rendered with the Section Rendering API (?section_id=cart-drawer).
   ========================================================================== */
(function () {
  'use strict';

  var LR = window.LR;
  var $ = LR.$;
  var $$ = LR.$$;
  var doc = document;

  var Cart = {
    busy: false,

    jsonHeaders: { 'Content-Type': 'application/json', Accept: 'application/json' },

    url: function (path) {
      return (LR.routes[path] || '') + '.js';
    },

    refresh: function () {
      return fetch((LR.routes.cart || '/cart') + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-cart-content]', parsed);
          var current = $('[data-cart-content]');
          if (fresh && current) current.replaceWith(doc.importNode(fresh, true));
          var count = fresh ? parseInt(fresh.getAttribute('data-count') || '0', 10) : 0;
          Cart.setCount(count);
          return count;
        });
    },

    setCount: function (n) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.classList.add('is-bump');
        setTimeout(function () { el.classList.remove('is-bump'); }, 350);
      });
    },

    openDrawer: function () {
      if (LR.settings.cartType === 'page' || !$('[data-drawer="cart"]')) {
        window.location.href = LR.routes.cart || '/cart';
        return;
      }
      LR.Drawers.open('cart');
    },

    add: function (variantId, quantity, properties) {
      var item = { id: Number(variantId), quantity: quantity || 1 };
      if (properties) item.properties = properties;
      return fetch(Cart.url('cartAdd'), {
        method: 'POST',
        headers: Cart.jsonHeaders,
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) {
            var err = new Error(data.description || data.message || LR.strings.error);
            err.userMessage = data.description || data.message || LR.strings.error;
            throw err;
          }
          return data;
        });
      }).then(function (data) {
        return Cart.refresh().then(function () { return data; });
      });
    },

    change: function (line, quantity) {
      return fetch(Cart.url('cartChange'), {
        method: 'POST',
        headers: Cart.jsonHeaders,
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) {
        if (!r.ok) throw new Error(LR.strings.error);
        return Cart.refresh();
      });
    },

    update: function (payload) {
      return fetch(Cart.url('cartUpdate'), {
        method: 'POST',
        headers: Cart.jsonHeaders,
        body: JSON.stringify(payload)
      }).then(function (r) { return r.json(); });
    },

    fetchCart: function () {
      return fetch(Cart.url('cart')).then(function (r) { return r.json(); });
    }
  };
  LR.Cart = Cart;
  LR.routes.cartJsPath = LR.routes.cart;

  /* header bag + any [data-cart-open] opens the drawer (page cart as the fallback) */
  doc.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (!opener) return;
    if (LR.settings.cartType === 'page' || !$('[data-drawer="cart"]')) return;
    e.preventDefault();
    Cart.refresh().then(Cart.openDrawer, Cart.openDrawer);
  });

  /* quick add (product cards + "Goes with it") */
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    if (Cart.busy) return;
    Cart.busy = true;
    var label = btn.getAttribute('data-label') || btn.textContent;
    var addedLabel = btn.getAttribute('data-added') || LR.strings.added;
    var noOpen = btn.hasAttribute('data-no-open');
    Cart.add(btn.getAttribute('data-variant-id'), 1)
      .then(function () {
        btn.classList.add('is-added');
        btn.textContent = addedLabel;
        setTimeout(function () {
          if (document.body.contains(btn)) {
            btn.classList.remove('is-added');
            btn.textContent = label;
          }
          if (!noOpen && LR.settings.openCartOnAdd) Cart.openDrawer();
        }, 900);
      })
      .catch(function (err) { LR.toast(err.userMessage || LR.strings.error); })
      .then(function () { Cart.busy = false; });
  });

  /* quantity +/- and remove inside the bag */
  doc.addEventListener('click', function (e) {
    var qty = e.target.closest('[data-cart-qty]');
    var rm = e.target.closest('[data-cart-remove]');
    if (!qty && !rm) return;
    e.preventDefault();
    if (Cart.busy) return;
    Cart.busy = true;
    var line = Number((qty || rm).getAttribute(qty ? 'data-cart-qty' : 'data-cart-remove'));
    var row = (qty || rm).closest('.cline');
    var current = row ? parseInt($('.qty__val', row).textContent, 10) : 1;
    var next = rm ? 0 : Math.max(0, current + Number(qty.getAttribute('data-delta')));
    Cart.change(line, next)
      .catch(function () { LR.toast(LR.strings.error); })
      .then(function () { Cart.busy = false; });
  });

  /* gift wrap + handwritten message */
  function saveGift() {
    var toggle = $('[data-gift-toggle]');
    var msg = $('[data-gift-message]');
    if (!toggle) return Promise.resolve();
    var on = toggle.checked;
    return Cart.update({
      attributes: {
        'Gift wrap': on ? 'Yes' : '',
        'Gift message': on && msg ? msg.value : ''
      }
    });
  }
  doc.addEventListener('change', function (e) {
    var toggle = e.target.closest('[data-gift-toggle]');
    if (!toggle) return;
    var msg = $('[data-gift-message]');
    if (msg) msg.hidden = !toggle.checked;
    var wrapVariant = LR.settings.giftWrapVariant;
    var chain = Promise.resolve();
    if (wrapVariant) {
      chain = Cart.fetchCart().then(function (cart) {
        var idx = -1;
        cart.items.forEach(function (it, i) { if (it.variant_id === Number(wrapVariant)) idx = i; });
        if (toggle.checked && idx === -1) return Cart.add(wrapVariant, 1);
        if (!toggle.checked && idx !== -1) return Cart.change(idx + 1, 0);
        return null;
      });
    }
    chain.then(saveGift).then(function () { return Cart.refresh(); }).catch(function () { LR.toast(LR.strings.error); });
  });
  doc.addEventListener('input', LR.debounce(function (e) {
    if (e.target.closest && e.target.closest('[data-gift-message]')) saveGift();
  }, 500));

  /* discount code: stored for checkout via /discount/CODE */
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();
    var code = $('input[name="code"]', form).value.trim();
    if (!code) return;
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok && r.status !== 0) throw new Error('bad');
        LR.toast(LR.strings.discountApplied);
        $('input[name="code"]', form).value = '';
      })
      .catch(function () { LR.toast(LR.strings.discountFailed); });
  });
})();
/* =============================================================================
   Product page: variant picker with stock states, gallery + lightbox, back-in-stock request,
   sticky bar, wishlist (saved on the device), recently viewed, complete-the-set recommendations.
   ========================================================================== */
(function () {
  'use strict';

  var LR = window.LR;
  var $ = LR.$;
  var $$ = LR.$$;
  var doc = document;
  var S = function () { return LR.strings || {}; };

  /* ---------- helpers to build small DOM cards without innerHTML ------------- */
  function el(tag, cls, text) {
    var n = doc.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function money(cents) {
    return (LR.currency || '') + ' ' + (Number(cents) / 100).toFixed(2);
  }
  function imgUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }
  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) {
      if (!r.ok) throw new Error('missing');
      return r.json();
    });
  }

  /* ---------- wishlist (localStorage, no app) -------------------------------- */
  var Wish = {
    key: 'lr_wish',
    list: function () { return LR.store.get(this.key) || []; },
    has: function (h) { return this.list().indexOf(h) > -1; },
    toggle: function (h) {
      var l = this.list();
      var i = l.indexOf(h);
      if (i > -1) l.splice(i, 1); else l.unshift(h);
      LR.store.set(this.key, l.slice(0, 50));
      return i === -1;
    }
  };

  function syncWishButtons() {
    $$('[data-wishlist-toggle]').forEach(function (b) {
      var on = Wish.has(b.getAttribute('data-handle'));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', b.getAttribute(on ? 'data-label-saved' : 'data-label-add') || '');
    });
  }

  function renderWishlist() {
    var box = $('[data-wishlist-list]');
    if (!box) return;
    var handles = Wish.list();
    if (!handles.length) {
      box.replaceChildren(el('p', 'wish-empty', S().wishlistEmpty || ''));
      return;
    }
    box.replaceChildren();
    handles.forEach(function (h) {
      fetchProduct(h).then(function (p) {
        var a = el('a', 'wish-item');
        a.href = p.url;
        var imgWrap = el('span', 'wish-item__img');
        if (p.featured_image) {
          var im = doc.createElement('img');
          im.src = imgUrl(p.featured_image, 160);
          im.alt = '';
          im.loading = 'lazy';
          imgWrap.appendChild(im);
        }
        var meta = el('span');
        meta.appendChild(el('span', 'wish-item__title', p.title));
        meta.appendChild(doc.createElement('br'));
        meta.appendChild(el('span', 'wish-item__price', money(p.price)));
        a.appendChild(imgWrap);
        a.appendChild(meta);
        box.appendChild(a);
      }).catch(function () { /* product no longer exists */ });
    });
  }

  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    var added = Wish.toggle(b.getAttribute('data-handle'));
    syncWishButtons();
    LR.toast(added ? S().toastSaved : S().toastRemoved);
  });
  doc.addEventListener('lr:drawer-open', function (e) {
    if (e.detail && e.detail.name === 'wishlist') renderWishlist();
  });

  /* ---------- product section --------------------------------------------------- */
  function initProduct(section) {
    var jsonEl = $('[data-product-json]');
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var form = $('[data-product-form]', section);
    if (!form) return;
    var variantInput = $('[data-variant-input]', form);
    var atc = $('[data-atc]', form);
    var stock = $('[data-stock-note]', section);
    var priceEl = $('[data-price]', section);
    var options = $$('[data-option]', form);
    var notify = $('[data-notify]', section);
    var notifyBody = notify ? $('[data-notify-body]', notify) : null;
    var stickyBtn = $('[data-sticky-btn]');
    var stickySel = $('[data-sticky-selection]');
    var addLabel = S().addToBag;
    var flashing = false;

    if (notify && !$('.notify__msg', notify)) notify.hidden = true;

    function selection() {
      return options.map(function (fs) {
        var c = $('input[data-option-value]:checked', fs);
        return c ? c.value : null;
      });
    }
    function matches(v, sel) {
      return sel.every(function (s, i) { return s === null || v.options[i] === s; });
    }
    function find(sel) {
      return data.variants.filter(function (v) { return matches(v, sel); })[0] || null;
    }

    function setSlide(mediaId) {
      if (mediaId == null) return;
      var id = String(mediaId);
      var found = false;
      $$('[data-slide]', section).forEach(function (s) {
        var on = s.getAttribute('data-media-id') === id;
        if (on) found = true;
      });
      if (!found) return;
      $$('[data-slide]', section).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') === id); });
      $$('[data-thumb]', section).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media-id') === id); });
    }

    function paintButtons(label, disabled, added) {
      [atc, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.textContent = label;
        b.disabled = !!disabled;
        b.classList.toggle('is-added', !!added);
      });
    }

    function update() {
      var sel = selection();
      var complete = sel.every(function (s) { return s !== null; });
      var single = options.length === 0;
      var v = single ? data.variants[0] : (complete ? find(sel) : null);

      // line-through for values with no available variant given the other choices
      options.forEach(function (fs, i) {
        $$('input[data-option-value]', fs).forEach(function (inp) {
          var test = sel.slice();
          test[i] = inp.value;
          var any = data.variants.some(function (vr) { return matches(vr, test) && vr.available; });
          var lab = inp.nextElementSibling;
          if (lab) lab.classList.toggle('is-unavailable', !any);
        });
        var lbl = $('[data-selected-label]', fs);
        if (lbl && sel[i]) lbl.textContent = sel[i];
      });

      var state = 'pick';
      if (single || complete) state = v && v.available ? 'ok' : 'soldout';

      if (v) {
        variantInput.value = v.id;
        if (priceEl && v.priceHtml) LR.setHTML(priceEl, v.priceHtml);
        setSlide(v.mediaId);
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        } catch (err) { /* ignore */ }
      }

      var noteText = '';
      if (state === 'pick') {
        noteText = data.pickLabel;
      } else if (state === 'soldout') {
        noteText = S().outStock;
      } else if (v.tracked && v.qty > 0 && v.qty <= (LR.settings.lowStock || 3)) {
        noteText = S().lowStock;
      } else if (S().shipsIn) {
        noteText = (S().inStockShips || '').replace('__DAYS__', S().shipsIn);
      } else {
        noteText = S().inStock;
      }
      if (stock) stock.textContent = noteText;

      if (!flashing) {
        if (state === 'pick') paintButtons(data.pickLabel, true, false);
        else if (state === 'soldout') paintButtons(S().soldOut, true, false);
        else paintButtons(addLabel, false, false);
      }

      if (notify && !$('.notify__msg', notify)) {
        var showNotify = state === 'soldout' && v;
        notify.hidden = !showNotify;
        if (showNotify && notifyBody) {
          notifyBody.value = (data.notifyMessage || '').replace('__P__', data.title).replace('__V__', v.title);
        }
      }

      if (stickySel) {
        stickySel.textContent = complete && !single ? sel.join(' · ') : (single ? '' : data.pickLabel);
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-value]')) update();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled || flashing) return;
      flashing = true;
      LR.Cart.add(variantInput.value, 1)
        .then(function () {
          paintButtons(S().added, false, true);
          setTimeout(function () {
            flashing = false;
            update();
            if (LR.settings.openCartOnAdd) LR.Cart.openDrawer();
          }, 900);
        })
        .catch(function (err) {
          flashing = false;
          LR.toast(err.userMessage || S().error);
          update();
        });
    });

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (atc.disabled) {
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (form.requestSubmit) form.requestSubmit(); else atc.click();
      });
    }

    // gallery thumbs + lightbox
    section.addEventListener('click', function (e) {
      var th = e.target.closest('[data-thumb]');
      if (th) { setSlide(th.getAttribute('data-media-id')); return; }
      var z = e.target.closest('[data-zoom-open]');
      var dlg = $('[data-lightbox]');
      if (z && dlg && dlg.showModal) {
        var im = $('[data-lightbox-img]', dlg);
        im.src = z.getAttribute('data-zoom-src');
        im.alt = data.title;
        dlg.showModal();
      }
    });
    var lightbox = $('[data-lightbox]');
    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.closest('[data-lightbox-close]')) lightbox.close();
      });
    }

    update();

    // remember this piece for "Recently viewed"
    var recent = LR.store.get('lr_recent') || [];
    recent = [data.handle].concat(recent.filter(function (h) { return h !== data.handle; })).slice(0, 8);
    LR.store.set('lr_recent', recent);
  }

  /* ---------- recently viewed ------------------------------------------------------- */
  function initRecent(section) {
    var current = section.getAttribute('data-current');
    var list = (LR.store.get('lr_recent') || []).filter(function (h) { return h !== current; }).slice(0, 5);
    var track = $('[data-recent-list]', section);
    if (!list.length || !track) return;
    var shown = 0;
    list.forEach(function (h) {
      fetchProduct(h).then(function (p) {
        var a = el('a', 'rcard');
        a.href = p.url;
        var imgWrap = el('span', 'rcard__img');
        if (p.featured_image) {
          var im = doc.createElement('img');
          im.src = imgUrl(p.featured_image, 360);
          im.alt = '';
          im.loading = 'lazy';
          imgWrap.appendChild(im);
        }
        a.appendChild(imgWrap);
        a.appendChild(el('span', 'rcard__title', p.title));
        track.appendChild(a);
        shown += 1;
        section.hidden = false;
      }).catch(function () { /* removed product */ });
    });
  }

  /* ---------- complete the set: Shopify complementary recommendations ------------------- */
  function initCompleteSet(section) {
    var url = section.getAttribute('data-recs-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var grid = $('[data-complete-set-grid]', parsed);
        var target = $('[data-complete-set-grid]', section);
        if (!grid || !target || !grid.children.length) return;
        var nodes = Array.prototype.slice.call(grid.children).map(function (n) { return doc.importNode(n, true); });
        target.replaceChildren.apply(target, nodes);
        section.hidden = false;
      })
      .catch(function () { /* nothing to recommend */ });
  }

  function init() {
    syncWishButtons();
    $$('[data-product-section]').forEach(initProduct);
    $$('[data-recent]').forEach(initRecent);
    $$('[data-complete-set]').forEach(initCompleteSet);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();
